import { Datatype } from '@framework/engine';
import { ISODate } from '@framework/ui';

/**
 * Restituisce una funzione di rendering basata sul tipo di dato.
 */
export function getRenderByDatatype(type: Datatype | undefined) {
  switch (type) {
    case Datatype.String:
      return (value: string) => <span>{value}</span>;
    case Datatype.Number:
      return (value: number) => <span>{value}</span>;
    case Datatype.Date:
      return (value: Date) => <ISODate date={value} />;
    case Datatype.Boolean:
      return (value: boolean) => <span>{value ? 'Sì' : ''}</span>;
    default:
      return (value: any) => <span>{String(value)}</span>;
  }
}
